import { Fragment } from "react";

export default function Users({ usersData, handleNavigate, trendingUsersTitle }) {
    return (
        <Fragment>
            <div className="w-full px-2">
                {/* Heading for Trending Users Section */}
                {trendingUsersTitle && <div className="flex items-center justify-between py-2">
                    <p className="text-[14px] font-bold text-blue-600">{trendingUsersTitle}</p>
                </div>}
                {usersData?.map((data) => {
                    const user = data?.user || data;
                    const mutualFriends = data?.mutual_friends || user?.mutual_friends || [];
                    return (
                        <div
                            key={user?.id}
                            className="flex flex-row items-center pb-3 text-black cursor-pointer dark:text-white"
                        >
                            <img
                                alt={user?.full_name}
                                src={user?.avatar_url}
                                onClick={() => handleNavigate(user?.id)}
                                className="h-10 w-10 rounded-full border border-gray-300 dark:border-gray-800 object-cover"
                            />
                            <div className="ml-2">
                                <p
                                    onClick={() => handleNavigate(user?.id)}
                                    className="text-[14px] md:text-[12px] dark:text-[white] font-bold first-letter:uppercase line-clamp-2"
                                >
                                    {user?.full_name}
                                </p>
                                <div className="flex items-center space-x-1">
                                    <p className="text-[10px] line-clamp-1 font-semibold text-gray-500">
                                        @{user?.username}
                                    </p>
                                    <span className="text-[10px] font-semibold text-gray-500">|</span>
                                    <p className="text-[10px] font-semibold text-gray-500">
                                        {user?.followers_count} followers
                                    </p>
                                </div>
                                <p className="text-[10px] text-gray-600 dark:text-gray-400">
                                    {mutualFriends?.length > 0 ?
                                        `Followed By ${mutualFriends[0]?.username} 
                                            ${mutualFriends?.length > 1 ? `+${mutualFriends?.length - 1} others` : ""}`
                                        : ""
                                    }
                                </p>
                            </div>
                        </div>
                    );
                })}
                {!usersData?.length && (
                    <div className="flex justify-center items-center h-[25vh]">
                        <p className="text-[12px] text-gray-500">
                            No users found
                        </p>
                    </div>
                )}
            </div>
        </Fragment>
    );
}
